var form = document.querySelector('.buchung form');
form.addEventListener('submit', function(e){

	/*prepare*/
	e.preventDefault();
	var trigger = form.querySelector('.submit button');
	trigger.innerHTML = trigger.dataset.sending;
	form.querySelectorAll('.hint').forEach(function(hint){
		hint.remove();
	});

	/*create form data*/
	var data = new FormData(form);
	data.append('handle','form');
	data.append('subject',trigger.dataset.subject);
	data.append('receivers',trigger.dataset.receivers);

	/*post*/
	fetch('./', {
		method: 'POST',
		body: data
	})
	.then(function(response){
		return response.text();
	})
	.then(function(reply){

		/*feedback*/
		var hint = document.createElement('div');
		hint.className = 'hint';

		if(reply == 'success'){
			trigger.style.display = 'none';
			form.querySelector('.classic').style.display = 'none';
			hint.classList.add('success');
			hint.innerHTML = trigger.dataset.success;
		}else{
			trigger.innerHTML = trigger.dataset.label;
			hint.classList.add('error');
			hint.innerHTML = trigger.dataset.error;
			console.log(reply);
		}

		var line = document.createElement('div');
		line.className = 'line hint';
		line.append(hint);
		form.querySelector('.fields .rail').append(line);

	});

});
